import type * as Types from '../../../schemas/shopify/admin.types';

export type ArticleAnalyticPageInfoNodeFragment = Pick<Types.Article, 'id' | 'title' | 'handle'> & {
  blog: Pick<Types.Blog, 'handle'>;
};

export const ArticleAnalyticPageInfoNodeFragmentDoc = `
    fragment ArticleAnalyticPageInfoNode on Article {
  id
  title
  handle
  blog {
    handle
  }
}
    `;
